export enum HoldingStatus {
  None = 0,
  Canceled = 1,
  Fundraising = 2,
  Owned = 3,
  FundAsset = 4,
  Draft = 5,
  Realized = 6
}

// tslint:disable-next-line:no-namespace
export namespace HoldingStatus {
  export function toString(status: HoldingStatus): string {
    switch (status) {
      case HoldingStatus.Fundraising:
        return 'Fundraising';
      case HoldingStatus.Owned:
        return 'Under Management';
      case HoldingStatus.Canceled:
        return 'Canceled';
      case HoldingStatus.FundAsset:
        return 'Fund Asset';
      case HoldingStatus.Draft:
        return 'Draft';
      case HoldingStatus.Realized:
        return 'Realized';
      default:
        return null;
    }
  }

  export function parse(statusStr: string): HoldingStatus {
    return HoldingStatus[statusStr];
  }

  export function listAll() {
    return [HoldingStatus.Draft, HoldingStatus.Fundraising, HoldingStatus.Owned, HoldingStatus.Realized];
  }
}

export default HoldingStatus;
